import React from "react";

import { MainRoutes } from "./Pages/MainRoutes";
import ErrorBoundary from "./Components/ErrorBoundary";

function App() {
  return (
    <div>
      <ErrorBoundary>
        <MainRoutes />
      </ErrorBoundary>
    </div>
  );
}

export default App;
